import BrandLogo from './brand/BrandLogo';

const DEFAULT_PALETTE = {
  primary: '#02142C',
  accent: '#FF7300',
  onPrimary: '#FFFFFF',
  muted: '#d1d5db',
  border: 'rgba(255,255,255,0.1)',
  font: '#FFFFFF',
  fontSecondary: '#d1d5db'
};
const DEFAULT_CONTACT = {
  address: '',
  phone: '',
  email: ''
};

const LandingFooter = ({
  palette = DEFAULT_PALETTE,
  contact = DEFAULT_CONTACT
}) => {
  const resolvedPalette = { ...DEFAULT_PALETTE, ...(palette || {}) };
  const resolvedContact = { ...DEFAULT_CONTACT, ...(contact || {}) };
  const containerStyle = { maxWidth: 1200, margin: '0 auto', padding: '0 20px' };
  const navTextColor = resolvedPalette.fontSecondary || resolvedPalette.onPrimary || DEFAULT_PALETTE.onPrimary;
  const bodyText = navTextColor;
  const socials = [
    { key: 'google', icon: 'fa-brands fa-google', url: resolvedContact.google },
    { key: 'facebook', icon: 'fa-brands fa-facebook', url: resolvedContact.facebook },
    { key: 'whatsapp', icon: 'fa-brands fa-whatsapp', url: resolvedContact.whatsapp },
    { key: 'instagram', icon: 'fa-brands fa-instagram', url: resolvedContact.instagram }
  ].filter((item) => Boolean(item.url));

  return (
    <footer
      id="contact"
      style={{
        position: 'relative',
        zIndex: 1030,
        background: resolvedPalette.primary,
        color: navTextColor,
        padding: '60px 0',
        marginTop: 'auto'
      }}
    >
      <div className="max-container" style={containerStyle}>
        <div className="row">
          <div className="col-md-3 mb-4">
            <div className="d-flex align-items-center gap-2 mb-3">
              <BrandLogo height={38} onDark showTagline />
            </div>
            <p style={{ color: bodyText, fontSize: 14 }}>
              One link for every food experience, from street vendors to hospitality groups.
            </p>
          </div>
          <div className="col-md-2 mb-4">
            <h5 style={{ color: navTextColor }}>Product</h5>
            <ul className="list-unstyled" style={{ color: bodyText, fontSize: 14 }}>
              <li><a href="/#features" style={{ color: bodyText, textDecoration: 'none' }}>Features</a></li>
              <li><a href="/#pricing" style={{ color: bodyText, textDecoration: 'none' }}>Pricing</a></li>
              <li><a href="/#experiences" style={{ color: bodyText, textDecoration: 'none' }}>Business Experiences</a></li>
            </ul>
          </div>
          <div className="col-md-2 mb-4">
            <h5 style={{ color: navTextColor }}>Resources</h5>
            <ul className="list-unstyled" style={{ color: bodyText, fontSize: 14 }}>
              <li><a href="/#about" style={{ color: bodyText, textDecoration: 'none' }}>About</a></li>
              <li><a href="/#find-food" style={{ color: bodyText, textDecoration: 'none' }}>Find Food</a></li>
              <li><a href="/#experiences" style={{ color: bodyText, textDecoration: 'none' }}>Five Experiences</a></li>
            </ul>
          </div>
          <div className="col-md-2 mb-4">
            <h5 style={{ color: navTextColor }}>Legal</h5>
            <ul className="list-unstyled" style={{ color: bodyText, fontSize: 14 }}>
              <li>Privacy</li>
              <li><a href="/subscription-terms" style={{ color: bodyText, textDecoration: 'none' }}>Payment Terms</a></li>
              <li><a href="/refund-policy" style={{ color: bodyText, textDecoration: 'none' }}>Refund Policy</a></li>
              <li><a href="/policies" style={{ color: bodyText, textDecoration: 'none' }}>Corporate Policies</a></li>
              <li><a href="/customer-terms" style={{ color: bodyText, textDecoration: 'none' }}>Customer Terms &amp; Privacy</a></li>
              <li>Security</li>
            </ul>
          </div>
          <div className="col-md-3 mb-4">
            <h5 style={{ color: navTextColor }}>Contact</h5>
            <ul className="list-unstyled" style={{ color: bodyText, fontSize: 14 }}>
              <li>{resolvedContact.address || <span style={{ opacity: 0.8 }}>Address not set</span>}</li>
              {resolvedContact.phone ? (
                <li>
                  <a href={`tel:${resolvedContact.phone}`} style={{ color: bodyText, textDecoration: 'none' }}>
                    {resolvedContact.phone}
                  </a>
                </li>
              ) : (
                <li style={{ opacity: 0.8 }}>Phone not set</li>
              )}
              {resolvedContact.email ? (
                <li>
                  <a href={`mailto:${resolvedContact.email}`} style={{ color: bodyText, textDecoration: 'none' }}>
                    {resolvedContact.email}
                  </a>
                </li>
              ) : (
                <li style={{ opacity: 0.8 }}>Email not set</li>
              )}
            </ul>
            {socials.length > 0 && (
              <div className="d-flex align-items-center gap-3 mt-2">
                {socials.map((item) => (
                  <a
                    key={item.key}
                    href={item.url}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: navTextColor, fontSize: 18 }}
                  >
                    <i className={item.icon} />
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center pt-3 border-top" style={{ borderColor: navTextColor }}>
          <p className="mb-0" style={{ color: bodyText }}>
            © {new Date().getFullYear()} Link my Food. All rights reserved.
          </p>
          <div className="d-flex gap-3" style={{ color: bodyText }}>
            <i className="fa-brands fa-twitter" />
            <i className="fa-brands fa-github" />
            <i className="fa-brands fa-linkedin" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;


